import React from 'react';
const Block = () => (
  <svg
    enableBackground="new 0 0 36 36"
    height="16px"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 36 36"
    width="16px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="CustomIcon"
  >
    <path
      d="M18,0.5c-9.925,0-18,8.075-18,18c0,9.926,8.075,18,18,18c9.926,0,18-8.074,18-18C36,8.575,27.926,0.5,18,0.5  z M18,5.5c2.683,0,5.178,0.817,7.25,2.215L7.215,25.75C5.817,23.678,5,21.183,5,18.5C5,11.332,10.832,5.5,18,5.5z M18,31.5  c-2.683,0-5.177-0.817-7.25-2.215L28.785,11.25C30.183,13.323,31,15.817,31,18.5C31,25.668,25.168,31.5,18,31.5z"
      fill="#6B6C7B"
    />
  </svg>
);
export default Block;
